import { SelectOption } from '../../types';

export const markInvalidOptions = (
  options: SelectOption[],
  validItems: number[]
) =>
  options.map((option) => {
    const validItem = validItems.find((i) => i === option.value.id);
    return {
      ...option,
      value: {
        ...option.value,
        highlight: !validItem,
      },
    };
  });



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/markInvalidOptions.ts